






































import {Component, Prop} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';

import DimensionsMixin from '@/components/datatable/dimensions-mixin';
import UrlMixin from '@/components/query/url-mixin';

import { normalizeId } from '@/components/datatable/table-selection';
import { DrillFilterOptionsEnum } from '@/services/models/Enums';


@Component({
  components: {
    Report: () => import('@/views/Report.vue'),
  }
})
export default class Tree extends mixins<DimensionsMixin, UrlMixin>(DimensionsMixin, UrlMixin){
  @Prop({ default: {} })
  item: any;

  @Prop({ default: {} })
  columnsWidth: any;

  @Prop()
  grouping: string;

  @Prop({ default: 0 })
  treeLevel: number;

  @Prop()
  treeView!: any[];

  @Prop(String)
  type!: string;

  rowKey: string = 'DT_RowId'

  @Prop()
  previousFilter!: Bemob.ReportQueryDrill[];

  emptyRows: { [type: string]: any} = {};

  onDrilldownForward() {
    this.$emit('drilldown-forward', this.normalizedItem, this.grouping)
  }

  get tableProgressBlockVisible() {
    return this.$store.state.table.progressBlockVisible
  }

  get leftOffset() {
    return 27 * (this.treeLevel + 1)
  }

  subReportTotal(total) {
    if(total === 0) {
        this.$set(this.emptyRows, this.filterValues, this.parentRow);
    }
  }

  get normalizedItem() {
    const id = normalizeId(this.item[this.rowKey]);
    return {
      ...this.item,
      [this.rowKey]: id,
      id: id
    }
  }

  get parentRow() {
    return {
      ...this.item,
    }
  }

  get filterOptions() {
    return DrillFilterOptionsEnum.equals;
  }

  get filterTables() {
    return this.getGroupByMetric(this.grouping) || this.type;
  }

  get filterValues() {
    return normalizeId(this.item.DT_RowId);
  }

  get computedPreviousFilter() {
    const options = {
      filterTables: this.filterTables,
      filterValues: this.filterValues,
      filterOptions: this.filterOptions,
    }

    return this.previousFilter
      ? this.previousFilter.concat([options])
      : this.filterTables && this.filterValues
        ? [options]
        : undefined;

  }

  get view() {
    return this.treeView || this.$store.getters.tableQueryForCurrentTab.treeLevels;
  }

  get computedTreeView() {
    if(!this.view) return;
    return Array.from(this.view).slice(1, this.view.length)
  }

  get next() {
    return this.view?.[0];
  }

  get rowTitle() {
    const type = this.next

    return this.dimensions[type] || type
  }


}
